import { setMinDuration } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import NumberFilter from './NumberFilter';
import { ReactElement } from 'react';

export const MinDurationFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicInputElement>): ReactElement => {
  const { t } = useTranslation();

  return (
    <NumberFilter
      filterName="minDuration"
      label={label ?? t('DurationLabel')}
      elementRef={elementRef}
      action={setMinDuration}
    />
  );
};

export default MinDurationFilter;
